import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import './styles/mobileRangePicker.css'

import * as React from 'react'
import * as ReactDOMClient from 'react-dom/client'

// Use consistent styling
import 'sanitize.css/sanitize.css'
import 'react-toastify/dist/ReactToastify.css'
// Import root app

import { HelmetProvider } from 'react-helmet-async'

import reportWebVitals from 'reportWebVitals'

// Initialize languages
import WebFont from 'webfontloader'
import App from 'App'


if (process.env.NODE_ENV !== 'development') {
	console.log = function noConsole() {};
}

WebFont.load({ google: { families: ['Roboto:300,400,500'] } })

const MOUNT_NODE = document.getElementById('root') as HTMLElement

ReactDOMClient.createRoot(MOUNT_NODE!).render(
	<HelmetProvider>
		<App />
	</HelmetProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
